module.exports = __webpack_public_path__ + "img/photo1_2.4db891cb.jpg";